import {errorMessages} from '../constants/constants';
import {ReactNode} from 'react';

export const getErrorMessage = (errors: string[], entity: string,
    className?: string) => {
  const messages: ReactNode[] = [];

  const classes = className ?
   `message-item error ${className}` : 'message-item error';

  if (!Array.isArray(errors)) {
    return <p className={classes}>{errorMessages.DEFAULT}</p>;
  }

  errors.forEach((key) => {
    if (key in errorMessages) {
      const message = (typeof errorMessages[key] === 'function') ?
        errorMessages[key](entity) : errorMessages[key];

      messages.push(<p key={key} className={classes}>{message}</p>);
    }
  });

  if (messages.length) {
    return messages;
  }

  return <p className={classes}>{errorMessages.DEFAULT}</p>;
};

export const handleApiValidationErrors = (error, entity: string) => {
  const {validationErrors={}} = error || {};
  const keys = Object.keys(validationErrors);

  const currentErrors = keys.reduce((acc, key) => {
    return {
      ...acc,
      [key]: getErrorMessage(validationErrors[key], entity)
    };
  }, {});

  return currentErrors;
};

